import db from './../db';

export default {
    delete: function(url) {
        return new Promise(function(resolve, reject) {
            var matches = url.match(/^\/api\/list\/(\d+)/);
            if (matches.length === 2) {
                const id = matches[1];

                let index = -1;
                for (let i = 0; i < db.list.length; i++) {
                    if (db.list[i].id === +id) {
                        index = i;
                    }
                }

                if (index >= 0) {
                    db.list.splice(index, 1);
                    db.save();
                    resolve({ body: {} });
                }
            }
            reject();
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/list/delete.js